export const NEW_NOTIFICATION_MESSAGE = "NEW_NOTIFICATION_MESSAGE";
export const OPEN_NOTIFICATION = "OPEN_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SET_NOTIFICATION_SEVERITY = "SET_NOTIFICATION_SEVERITY";
